export enum MobileIdentificationProvisioningBundleStatusType {
    Active = 1,
    Cancelled = 2,
    Suspended = 3,
    Unlinked = 4,
    Refreshed = 5
}
